import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logos/shopify.svg'
import _imports_1 from '@/assets/images/logos/woocommerce.svg'
import _imports_2 from '@/assets/images/logos/whatsapp.svg'


const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-slate-900" }
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 py-6" }
const _hoisted_3 = {
  class: "relative overflow-hidden rounded-2xl mb-8",
  style: {"background":"linear-gradient(135deg, #8B5CF6 0%, #7C3AED 50%, #6D28D9 100%)"}
}
const _hoisted_4 = { class: "relative p-8" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "text-2xl font-bold text-white" }
const _hoisted_7 = { class: "text-white/90 text-lg font-medium" }
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = { class: "space-y-6" }
const _hoisted_10 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-slate-700 opacity-75" }
const _hoisted_11 = { class: "p-4 sm:p-6" }
const _hoisted_12 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_13 = { class: "flex items-center gap-3 sm:gap-6 flex-1 min-w-0" }
const _hoisted_14 = { class: "min-w-0 flex-1" }
const _hoisted_15 = { class: "text-lg sm:text-xl font-semibold text-slate-900 dark:text-white mb-1 truncate" }
const _hoisted_16 = { class: "text-sm sm:text-base text-slate-600 dark:text-slate-300 mb-2 sm:mb-3 line-clamp-2" }
const _hoisted_17 = {
  disabled: "",
  class: "px-3 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm font-medium text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-xl cursor-not-allowed opacity-60 whitespace-nowrap flex-shrink-0"
}
const _hoisted_18 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-slate-700 opacity-75" }
const _hoisted_19 = { class: "p-4 sm:p-6" }
const _hoisted_20 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_21 = { class: "flex items-center gap-3 sm:gap-6 flex-1 min-w-0" }
const _hoisted_22 = { class: "min-w-0 flex-1" }
const _hoisted_23 = { class: "text-lg sm:text-xl font-semibold text-slate-900 dark:text-white mb-1 truncate" }
const _hoisted_24 = { class: "text-sm sm:text-base text-slate-600 dark:text-slate-300 mb-2 sm:mb-3 line-clamp-2" }
const _hoisted_25 = {
  disabled: "",
  class: "px-3 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm font-medium text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-xl cursor-not-allowed opacity-60 whitespace-nowrap flex-shrink-0"
}
const _hoisted_26 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-slate-700" }
const _hoisted_27 = { class: "p-4 sm:p-6" }
const _hoisted_28 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_29 = { class: "flex items-center gap-3 sm:gap-6 flex-1 min-w-0" }
const _hoisted_30 = { class: "min-w-0 flex-1" }
const _hoisted_31 = { class: "text-lg sm:text-xl font-semibold text-slate-900 dark:text-white mb-1 truncate" }
const _hoisted_32 = { class: "text-sm sm:text-base text-slate-600 dark:text-slate-300 mb-2 sm:mb-3 line-clamp-2" }
const _hoisted_33 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_34 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-2xl mx-4 z-10 relative border border-gray-200 dark:border-slate-600 overflow-hidden" }
const _hoisted_35 = {
  class: "relative overflow-hidden",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
}
const _hoisted_36 = { class: "relative px-6 py-4" }
const _hoisted_37 = { class: "flex items-center justify-between" }
const _hoisted_38 = { class: "flex items-center gap-3" }
const _hoisted_39 = { class: "text-xl font-bold text-white" }
const _hoisted_40 = { class: "p-6 space-y-6" }
const _hoisted_41 = { class: "space-y-3" }
const _hoisted_42 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_43 = { class: "flex gap-3" }
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "text-sm text-slate-500 dark:text-slate-400 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200 dark:border-blue-800" }
const _hoisted_46 = { class: "space-y-3" }
const _hoisted_47 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "text-sm text-slate-500 dark:text-slate-400 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg border border-amber-200 dark:border-amber-800" }
const _hoisted_50 = { class: "px-6 py-4 bg-gray-50 dark:bg-slate-700/50 border-t border-gray-200 dark:border-slate-600 flex items-center justify-end gap-3" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_53 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 dark:border-slate-600 overflow-hidden" }
const _hoisted_54 = {
  class: "relative overflow-hidden",
  style: {"background":"linear-gradient(135deg, #059669 0%, #047857 50%, #065F46 100%)"}
}
const _hoisted_55 = { class: "relative px-6 py-4" }
const _hoisted_56 = { class: "flex items-center justify-between" }
const _hoisted_57 = { class: "flex items-center gap-3" }
const _hoisted_58 = { class: "text-xl font-bold text-white" }
const _hoisted_59 = { class: "p-6" }
const _hoisted_60 = { class: "text-center mb-6" }
const _hoisted_61 = { class: "w-20 h-20 rounded-2xl bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 overflow-hidden mx-auto mb-4 flex items-center justify-center shadow-lg" }
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 1,
  src: _imports_2,
  alt: "WhatsApp",
  class: "w-10 h-10"
}
const _hoisted_64 = {
  key: 0,
  class: "text-center mb-6"
}
const _hoisted_65 = { class: "bg-white dark:bg-slate-700 rounded-2xl p-6 mb-4 shadow-inner border border-gray-200 dark:border-slate-600" }
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 1,
  class: "w-56 h-56 bg-gray-100 dark:bg-slate-600 flex items-center justify-center mx-auto rounded-xl"
}
const _hoisted_68 = { class: "text-sm text-slate-500 dark:text-slate-400" }
const _hoisted_69 = { class: "text-sm text-slate-600 dark:text-slate-400 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200 dark:border-blue-800" }
const _hoisted_70 = { class: "px-6 py-4 bg-gray-50 dark:bg-slate-700/50 border-t border-gray-200 dark:border-slate-600 space-y-3" }
const _hoisted_71 = {
  key: 2,
  class: "fixed bottom-6 right-6 max-w-sm z-50 transition-all duration-300"
}
const _hoisted_72 = { class: "bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg border border-gray-200 dark:border-slate-600 rounded-2xl shadow-2xl overflow-hidden" }
const _hoisted_73 = { class: "p-4" }
const _hoisted_74 = { class: "flex items-start gap-3" }
const _hoisted_75 = {
  key: 0,
  class: "w-4 h-4 text-emerald-600 dark:text-emerald-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_76 = {
  key: 1,
  class: "w-4 h-4 text-red-600 dark:text-red-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_77 = {
  key: 2,
  class: "w-4 h-4 text-blue-600 dark:text-blue-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_78 = { class: "flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
          _createElementVNode("div", { class: "absolute top-4 right-4 w-32 h-32 rounded-full bg-white/20" }),
          _createElementVNode("div", { class: "absolute -top-8 -right-8 w-24 h-24 rounded-full bg-white/10" }),
          _createElementVNode("div", { class: "absolute bottom-4 left-4 w-20 h-20 rounded-full bg-white/15" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg" }, [
              _createElementVNode("svg", {
                class: "w-8 h-8 text-white",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.directT('settings.connections.title')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('settings.connections.subtitle')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_SettingsNav)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 flex items-center justify-center p-2 sm:p-3 shadow-inner flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-full h-full object-contain",
                    alt: "Shopify"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.directT('settings.connections.shopify.name')), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.directT('settings.connections.shopify.description')), 1)
                ])
              ]),
              _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.directT('settings.connections.comingSoon')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 flex items-center justify-center p-2 sm:p-3 shadow-inner flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "w-full h-full object-contain",
                    alt: "WooCommerce"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.directT('settings.connections.woocommerce.name')), 1),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.directT('settings.connections.woocommerce.description')), 1)
                ])
              ]),
              _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.directT('settings.connections.comingSoon')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 flex items-center justify-center p-2 sm:p-3 shadow-inner flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "w-full h-full object-contain",
                    alt: "WhatsApp"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.directT('settings.connections.whatsapp.name')), 1),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.directT('settings.connections.whatsapp.description')), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openWhatsappPopup && _ctx.openWhatsappPopup(...args))),
                class: "px-3 py-2 sm:px-6 sm:py-3 text-xs sm:text-sm font-medium rounded-xl transition-all duration-200 transform hover:scale-105 whitespace-nowrap flex-shrink-0",
                style: _normalizeStyle(_ctx.isWhatsappConnected ? 
                  { 
                    background: 'linear-gradient(to right, #10b981, #059669)', 
                    color: 'white',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                  } : 
                  { 
                    background: 'linear-gradient(to right, #8b5cf6, #7c3aed)', 
                    color: 'white',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                  }),
                onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isWhatsappConnected ? 
                  ($event.target.style.background = 'linear-gradient(to right, #059669, #047857)') : 
                  ($event.target.style.background = 'linear-gradient(to right, #7c3aed, #6d28d9)'))),
                onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isWhatsappConnected ? 
                  ($event.target.style.background = 'linear-gradient(to right, #10b981, #059669)') : 
                  ($event.target.style.background = 'linear-gradient(to right, #8b5cf6, #7c3aed)')))
              }, _toDisplayString(_ctx.isWhatsappConnected ? _ctx.directT('settings.connections.whatsapp.connected') : _ctx.directT('settings.connections.whatsapp.configure')), 37)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.shopifyFormOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeShopifyForm && _ctx.closeShopifyForm(...args)))
          }),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
                _createElementVNode("div", { class: "absolute top-2 right-2 w-16 h-16 rounded-full bg-white/20" }),
                _createElementVNode("div", { class: "absolute -top-4 -right-4 w-12 h-12 rounded-full bg-white/10" })
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center p-2" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "w-full h-full object-contain",
                        alt: "Shopify"
                      })
                    ], -1)),
                    _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.directT('settings.connections.shopify.configTitle')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeShopifyForm && _ctx.closeShopifyForm(...args))),
                    class: "p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookUrl')), 1),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("input", {
                    type: "text",
                    value: _ctx.webhookUrl,
                    readonly: "",
                    class: "flex-1 px-4 py-3 bg-gray-50 dark:bg-slate-700 border border-gray-200 dark:border-slate-600 rounded-xl text-slate-600 dark:text-slate-300 font-medium cursor-not-allowed"
                  }, null, 8, _hoisted_44),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                    class: "px-4 py-3 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white rounded-xl transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:scale-105"
                  }, _toDisplayString(_ctx.directT('settings.connections.shopify.copy')), 1)
                ]),
                _createElementVNode("p", _hoisted_45, [
                  _cache[29] || (_cache[29] = _createElementVNode("svg", {
                    class: "w-4 h-4 inline mr-2 text-blue-500",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.connections.shopify.webhookUrlHint')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookSigningSecret')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.webhookSign) = $event)),
                  class: "w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm",
                  placeholder: _ctx.directT('settings.connections.shopify.webhookSigningSecret')
                }, null, 8, _hoisted_48), [
                  [_vModelText, _ctx.webhookSign]
                ]),
                _createElementVNode("p", _hoisted_49, [
                  _cache[30] || (_cache[30] = _createElementVNode("svg", {
                    class: "w-4 h-4 inline mr-2 text-amber-500",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.connections.shopify.webhookSigningSecretHint')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeShopifyForm && _ctx.closeShopifyForm(...args))),
                class: "px-6 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-700 border border-gray-200 dark:border-slate-600 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-600 transition-all duration-200 shadow-sm"
              }, _toDisplayString(_ctx.directT('settings.connections.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveShopifyConfig && _ctx.saveShopifyConfig(...args))),
                disabled: !_ctx.webhookSign,
                class: "px-6 py-2.5 text-sm font-medium text-white rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:scale-105 disabled:hover:scale-100",
                style: _normalizeStyle({
              background: !_ctx.webhookSign ? '#9CA3AF' : 'linear-gradient(to right, #10b981, #059669)',
              cursor: !_ctx.webhookSign ? 'not-allowed' : 'pointer'
            }),
                onMouseover: _cache[9] || (_cache[9] = ($event: any) => (!_ctx.webhookSign ? null : ($event.target.style.background = 'linear-gradient(to right, #059669, #047857)'))),
                onMouseout: _cache[10] || (_cache[10] = ($event: any) => (!_ctx.webhookSign ? null : ($event.target.style.background = 'linear-gradient(to right, #10b981, #059669)')))
              }, _toDisplayString(_ctx.directT('settings.connections.save')), 45, _hoisted_51)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.whatsappPopupOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeWhatsappPopup && _ctx.closeWhatsappPopup(...args)))
          }),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
                _createElementVNode("div", { class: "absolute top-2 right-2 w-16 h-16 rounded-full bg-white/20" }),
                _createElementVNode("div", { class: "absolute -top-4 -right-4 w-12 h-12 rounded-full bg-white/10" })
              ], -1)),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center p-2" }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "w-full h-full object-contain",
                        alt: "WhatsApp"
                      })
                    ], -1)),
                    _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.directT('settings.connections.whatsapp.configTitle')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeWhatsappPopup && _ctx.closeWhatsappPopup(...args))),
                    class: "p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                  }, _cache[32] || (_cache[32] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  (_ctx.whatsappProfilePicture)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.whatsappProfilePicture,
                        alt: "WhatsApp Profile",
                        class: "w-full h-full object-cover"
                      }, null, 8, _hoisted_62))
                    : (_openBlock(), _createElementBlock("img", _hoisted_63))
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "text-lg font-semibold text-slate-900 dark:text-white mb-2" }, " WhatsApp ", -1))
              ]),
              (_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      (_ctx.whatsappQrCodeData)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.whatsappQrCodeData,
                            alt: "WhatsApp QR Code",
                            class: "w-56 h-56 mx-auto rounded-xl shadow-lg"
                          }, null, 8, _hoisted_66))
                        : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.directT('settings.connections.whatsapp.loadingQR')), 1)
                          ]))
                    ]),
                    _createElementVNode("p", _hoisted_69, [
                      _cache[35] || (_cache[35] = _createElementVNode("svg", {
                        class: "w-4 h-4 inline mr-2 text-blue-500",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.connections.whatsapp.scanQrInstructions')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_70, [
              (!_ctx.isWhatsappConnected && !_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getWhatsappQRCode && _ctx.getWhatsappQRCode(...args))),
                    class: "w-full px-4 py-3 text-sm font-medium text-white rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105",
                    style: {
              background: 'linear-gradient(to right, #10b981, #059669)'
            },
                    onMouseover: _cache[14] || (_cache[14] = ($event: any) => ($event.target.style.background = 'linear-gradient(to right, #059669, #047857)')),
                    onMouseout: _cache[15] || (_cache[15] = ($event: any) => ($event.target.style.background = 'linear-gradient(to right, #10b981, #059669)'))
                  }, _toDisplayString(_ctx.directT('settings.connections.whatsapp.getQRCode')), 33))
                : _createCommentVNode("", true),
              (_ctx.isWhatsappConnected && !_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.disconnectWhatsapp && _ctx.disconnectWhatsapp(...args))),
                    class: "w-full px-4 py-3 text-sm font-medium text-white rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105",
                    style: {
              background: 'linear-gradient(to right, #ef4444, #dc2626)'
            },
                    onMouseover: _cache[17] || (_cache[17] = ($event: any) => ($event.target.style.background = 'linear-gradient(to right, #dc2626, #b91c1c)')),
                    onMouseout: _cache[18] || (_cache[18] = ($event: any) => ($event.target.style.background = 'linear-gradient(to right, #ef4444, #dc2626)'))
                  }, _toDisplayString(_ctx.directT('settings.connections.whatsapp.disconnect')), 33))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeWhatsappPopup && _ctx.closeWhatsappPopup(...args))),
                class: "w-full px-4 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-700 border border-gray-200 dark:border-slate-600 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-600 transition-all duration-200 shadow-sm"
              }, _toDisplayString(_ctx.directT('settings.connections.cancel')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", {
              class: _normalizeClass(["h-1", {
            'bg-gradient-to-r from-emerald-400 to-emerald-600': _ctx.toastType === 'success',
            'bg-gradient-to-r from-red-400 to-red-600': _ctx.toastType === 'error',
            'bg-gradient-to-r from-blue-400 to-blue-600': _ctx.toastType === 'info'
          }])
            }, null, 2),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center", {
                'bg-emerald-100 dark:bg-emerald-900/30': _ctx.toastType === 'success',
                'bg-red-100 dark:bg-red-900/30': _ctx.toastType === 'error',
                'bg-blue-100 dark:bg-blue-900/30': _ctx.toastType === 'info'
              }])
                }, [
                  (_ctx.toastType === 'success')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_75, _cache[36] || (_cache[36] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 13l4 4L19 7"
                        }, null, -1)
                      ])))
                    : (_ctx.toastType === 'error')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_76, _cache[37] || (_cache[37] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_77, _cache[38] || (_cache[38] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          }, null, -1)
                        ])))
                ], 2),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-sm font-medium", {
                  'text-emerald-800 dark:text-emerald-200': _ctx.toastType === 'success',
                  'text-red-800 dark:text-red-200': _ctx.toastType === 'error',
                  'text-blue-800 dark:text-blue-200': _ctx.toastType === 'info'
                }])
                  }, _toDisplayString(_ctx.toastMessage), 3)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
                  class: "text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700"
                }, _cache[39] || (_cache[39] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}